import { useMemo } from 'react'

import { AutomationsPresentationV1 } from 'Automations/automationEditor'
import { useResolvedNodeDefinitions } from 'Automations/automationEditor/atoms'
import { getUpstreamConditionalProperties } from 'Automations/nodeDefinitions/conditions/helpers'
import { ConditionalProperties } from 'Automations/nodeDefinitions/conditions'

/**
 * Resolves the conditional properties visible to a node. Reads the resolved
 * node-definition registry — populated once at editor load — so the lookup is
 * synchronous; any operators built from fetched account data (e.g. one per
 * customer custom-property key) are already concrete in that registry.
 */
export const useUpstreamConditionalProperties = (
  nodeId: string,
  presentation: AutomationsPresentationV1 | undefined
): ConditionalProperties | undefined => {
  const definitions = useResolvedNodeDefinitions()

  return useMemo(
    () =>
      presentation
        ? getUpstreamConditionalProperties({
            nodeId,
            presentation,
            definitions
          })
        : undefined,
    [nodeId, presentation, definitions]
  )
}
